var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        }
      },
      model: {
        value: _vm.valid,
        callback: function($$v) {
          _vm.valid = $$v
        },
        expression: "valid"
      }
    },
    [
      _c(
        "v-card-text",
        [
          _c(
            "v-container",
            {
              staticClass: "py-0",
              staticStyle: { "min-width": "100%" },
              attrs: { "grid-list-md": "" }
            },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  this.funcionario.item != null
                    ? _c("v-flex", { attrs: { md12: "" } }, [
                        _c("strong", [_vm._v("Nro de item :")]),
                        _vm._v(
                          " " + _vm._s(this.funcionario.item) + "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.funcionario.unidad != null
                    ? _c("v-flex", { attrs: { md12: "" } }, [
                        _c("strong", [_vm._v("Nombre padre:")]),
                        _vm._v(
                          " " +
                            _vm._s(this.funcionario.padres_unidad) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.funcionario.unidad != null
                    ? _c("v-flex", { attrs: { md12: "" } }, [
                        _c("strong", [_vm._v("Nombre unidad:")]),
                        _vm._v(
                          " " + _vm._s(this.funcionario.unidad) + "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.funcionario.cargo != null
                    ? _c("v-flex", { attrs: { md12: "" } }, [
                        _c("strong", [_vm._v("Cargo:")]),
                        _vm._v(
                          " " + _vm._s(this.funcionario.cargo) + "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.funcionario.puesto != null
                    ? _c("v-flex", { attrs: { md6: "" } }, [
                        _c("strong", [_vm._v("Puesto:")]),
                        _vm._v(
                          " " + _vm._s(this.funcionario.puesto) + "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.funcionario.sueldo != null
                    ? _c("v-flex", { attrs: { md6: "" } }, [
                        _c("strong", [_vm._v("Sueldo:")]),
                        _vm._v(
                          " " + _vm._s(this.funcionario.sueldo) + "\n        "
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              this.funcionario.item != 0
                ? _c(
                    "v-layout",
                    { attrs: { wrap: "", row: "" } },
                    [
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-radio-group",
                            {
                              attrs: {
                                row: "",
                                rules: [
                                  function(v) {
                                    if (v == null) {
                                      return "El campo es obligatorio."
                                    }
                                    return true
                                  }
                                ]
                              },
                              model: {
                                value: _vm.con_sin_sueldo,
                                callback: function($$v) {
                                  _vm.con_sin_sueldo = $$v
                                },
                                expression: "con_sin_sueldo"
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-radio", {
                                    attrs: { label: "Con sueldo", value: 1 }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-radio", {
                                    attrs: { label: "Sin sueldo", value: 2 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.funcionario.item != 0
                ? _c(
                    "v-layout",
                    { attrs: { wrap: "", row: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "date",
                              label: "Fecha desde",
                              rules: _vm.$validate(["required"]),
                              required: ""
                            },
                            on: {
                              change: function($event) {
                                return _vm.alertarAprobacion()
                              },
                              input: function($event) {
                                _vm.obtenerItemsDisponibles() &&
                                  _vm.esFeriadoOFinDeSemana(
                                    _vm.form.fecha_desde,
                                    1
                                  )
                              }
                            },
                            model: {
                              value: _vm.form.fecha_desde,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fecha_desde", $$v)
                              },
                              expression: "form.fecha_desde"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "date",
                              label: "Fecha de conclusión",
                              rules: _vm.$validate(["required"]),
                              required: ""
                            },
                            on: {
                              input: function($event) {
                                _vm.obtenerItemsDisponibles() &&
                                  _vm.esFeriadoOFinDeSemana(
                                    _vm.form.fecha_hasta,
                                    2
                                  )
                              }
                            },
                            model: {
                              value: _vm.form.fecha_hasta,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fecha_hasta", $$v)
                              },
                              expression: "form.fecha_hasta"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      this.form.id_estado != 1 &&
                      this.form.id_estado != 64 &&
                      this.form.id_estado != 53
                        ? _c(
                            "v-flex",
                            { attrs: { xs12: "", md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.itemsDisponibles,
                                  "item-text": "nro_item",
                                  "item-value": "nro_item",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  label: "ITEM",
                                  loading: _vm.loading
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.cargarDatos()
                                  }
                                },
                                model: {
                                  value: _vm.form.nro_item,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nro_item", $$v)
                                  },
                                  expression: "form.nro_item"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.data.id && this.funcionario.item != 0
                        ? _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              this.form.id_estado != 1 &&
                              this.form.id_estado != 64 &&
                              this.form.id_estado != 53
                                ? _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.unidades,
                                      "item-text": "nombre_unidad",
                                      "item-value": function(val) {
                                        return parseInt(val.id)
                                      },
                                      label: "Unidad",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      disabled: ""
                                    },
                                    on: { change: _vm.obtenerOrganigrama },
                                    model: {
                                      value: _vm.form.id_unidad,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "id_unidad", $$v)
                                      },
                                      expression: "form.id_unidad"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.data.id
                        ? _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              this.form.id_estado != 1 &&
                              this.form.id_estado != 64 &&
                              this.form.id_estado != 53
                                ? _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.unidades,
                                      "item-text": "nombre_unidad",
                                      "item-value": function(val) {
                                        return parseInt(val.id)
                                      },
                                      label: "Unidad",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.form.id_unidad,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "id_unidad", $$v)
                                      },
                                      expression: "form.id_unidad"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md6: "" } },
                        [
                          this.form.id_estado != 1 &&
                          this.form.id_estado != 64 &&
                          this.form.id_estado != 53
                            ? _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.lista_puestos,
                                  "item-text": "denominacion",
                                  "item-value": function(val) {
                                    return parseInt(val.id_puesto)
                                  },
                                  label: "Puesto",
                                  rules: _vm.$validate(["required"]),
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.form.id_puesto,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "id_puesto", $$v)
                                  },
                                  expression: "form.id_puesto"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md6: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.lista_cargos,
                              "item-text": "denominacion",
                              "item-value": function(val) {
                                return parseInt(val.id)
                              },
                              label: "Seleccione Cargo",
                              disabled: ""
                            },
                            model: {
                              value: _vm.form.id_cargo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "id_cargo", $$v)
                              },
                              expression: "form.id_cargo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c("small", { staticClass: "error--text text-required" }, [
            _vm._v("* Los campos son obligatorios")
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              nativeOn: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [
              _c("v-icon", [_vm._v("cancel")]),
              _vm._v(" " + _vm._s(_vm.$t("common.cancel")) + "\n    ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.fecha_futuro,
                  expression: "!fecha_futuro"
                }
              ],
              attrs: {
                color: "primary",
                type: "submit",
                loading: _vm.loading,
                disabled: !_vm.valid
              }
            },
            [
              _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
              _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n    ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b9ba652", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b9ba652","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/movilidad/components/ComisionInterinato.vue
// module id = null
// module chunks = 